import Vue from 'vue';
const files = require.context('./modules', false, /\.js$/);
const modules = {};

files.keys().forEach(key => {
  if (key === './index.js') return;
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default;
});

Vue.use({
  install(Vue) {
    Vue.prototype.$api = modules;
  },
});
